import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BmCreditorBankAccountBaseComponentBase} from "../bm-creditor-bank-account-base.component-base";

@Component({
    selector: 'bm-creditor-bank-account-side',
    templateUrl: 'bm-creditor-bank-account-side.component.html',
    styleUrls: ['bm-creditor-bank-account-side.component.scss'],
    standalone: false
})
export class BmCreditorBankAccountSideComponent extends BmCreditorBankAccountBaseComponentBase implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized



    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
